















import { Vue, Component, Prop } from 'vue-property-decorator'

export interface ButtonType {
  title: string
  value: string
}

@Component
export default class RadioButtonGroup extends Vue {
  @Prop({ required: true }) readonly buttons!: ButtonType[]
  @Prop({ required: true }) readonly selected!: boolean

  handleClick (value: string) {
    this.$emit('change', value)
  }
}
